import { setCookie } from "@/app/_lib/referral-utils";

const SIGNUP_ACQUISITION_COOKIE_MAX_AGE_SECONDS = 60 * 30; // 30 minutes

/**
 * Persist UTM params and document.referrer into short-lived cookies so the
 * server-side post-signin route can attach them to the sign_up_success event.
 * Only writes cookies that have a truthy value.
 */
export function storeAcquisitionCookies(urlParams: URLSearchParams): void {
  const utmSource = urlParams.get("utm_source");
  const utmMedium = urlParams.get("utm_medium");
  const utmCampaign = urlParams.get("utm_campaign");

  if (utmSource)
    setCookie(
      "signup_utm_source",
      utmSource,
      SIGNUP_ACQUISITION_COOKIE_MAX_AGE_SECONDS,
    );
  if (utmMedium)
    setCookie(
      "signup_utm_medium",
      utmMedium,
      SIGNUP_ACQUISITION_COOKIE_MAX_AGE_SECONDS,
    );
  if (utmCampaign)
    setCookie(
      "signup_utm_campaign",
      utmCampaign,
      SIGNUP_ACQUISITION_COOKIE_MAX_AGE_SECONDS,
    );

  if (typeof document !== "undefined" && document.referrer) {
    setCookie(
      "signup_referrer",
      document.referrer,
      SIGNUP_ACQUISITION_COOKIE_MAX_AGE_SECONDS,
    );
  }
}
